import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { ArquivoStorageService } from '../../../../folha-pagamento/src/common/services/arquivo-storage.service';
import { ArquivoUrl } from '../../../../folha-pagamento/src/common/interface/arquivo-url';

@Injectable()
export class PortalArquivoStorageService extends ArquivoStorageService {

  private readonly resourcePortal: string = '/api/portal-servidor/arquivo';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getUrlAssinada(fullPath: string, fileName: string): Observable<ArquivoUrl> {
    const params: string = `fullPath=${encodeURIComponent(fullPath)}&fileName=${encodeURIComponent(fileName)}`;

    return this.httpClient.get({
      resource: `${this.resourcePortal}/url-assinada?${params}`,
      disableSpinner: false
    });
  }
}
